export const baseUrl = 'https://api-sf.prypco.com';
